import { apiConfig } from "./apiConfig";
import { schedulerState } from "./calendar";
import { disPlayListOfServices } from "./disPlayListOfServices";
import { fullAddressRoundRobinApi } from "./fullAddressRoundRobinApi";
import { getFullAttributeApi } from "./getFullAttributeApi";
import { progressBarDisplay } from "./progressBarDisplay";
import { refreshScheduleData } from "./refreshScheduleData";
import { servieModal } from "./servicesListDisplayModal";

export function serviceSelectionEnables(postalCode:any){
    fullAddressRoundRobinApi(postalCode,false,()=>{
        getFullAttributeApi(window.objOSGlobal.requestBodyValues.WebLocationId,function(){
            if(servieModal.enable){
                schedulerState.numberOfSlot = 1;
                window.objOSGlobal.requestBodyValues.serviceSkuId = "";
                window.objOSGlobal.requestBodyValues.ServiceId = "";
                window.objOSGlobal.requestBodyValues.ServiceSkuIds = [];
                window.objOSGlobal.requestBodyValues.serviceName = "";
                if(!window.objOSGlobal.requestBodyValues.IsLeadOnly){
                    $(".tab-pane.fieldset").removeClass("active");
                    refreshScheduleData(new Date().getFullYear(), new Date().getMonth() + 1);
                    getInspectionFees(postalCode);
                    // $('.cal-inspection-fee').show();
                    // $('.cal-inspection-fee').text('An inspection fee will apply to this appointment.');
                    $('#calendar-screen').addClass('active');
                    $('.nav-wizard.progressbar').removeClass('hide-schedule');
                    $('.dvw-modal-header').hide();
                    $('.modal-header-one').hide();
                    $('.scheduler-modal .modal-content').removeClass('banner-wizard');
                }else{
                    $('.dvw-modal-header').hide();
                    $('.modal-header-one').hide();
                    $('.tab-pane.fieldset').removeClass('active');
                    $('.nav-wizard.progressbar').addClass('hide-schedule');
                    $('.contact-information-screen').addClass('active');
                    $('.progress-bar').css({ width:'3.2%' });
                    $('.scheduler-modal .modal-content').removeClass('banner-wizard');
                }
                progressBarDisplay()
            }else{
                disPlayListOfServices(postalCode);
            }
        });
    },'');
}


function getInspectionFees(postalCode:any){
    //let apiUrl = `${apiConfig.inspectionFees}${window.objOSGlobal.requestBodyValues.WebLocationId}?apikey=${window.DEFINE_VALUE.JS_API_KEY}`;
    let apiUrl = `${apiConfig.inspectionFees}${window.objOSGlobal.requestBodyValues.WebLocationId}/${postalCode}?apikey=${window.DEFINE_VALUE.JS_API_KEY}`;
    $.ajax({
        type: "GET",
        url:apiUrl,
        contentType: "application/json",
        dataType: 'json',
        async:false,
        success: function(result){
            if(result.length!=0){
                //  let inspectionFees = result[0].defaultFee;
                 let DigFeeObj = result.filter((obj:any) => obj.feeName==="Inspection Fee");
                 if(DigFeeObj.length > 0){
                    let mostRecentFee = DigFeeObj.reduce((a:any, b:any) => a.createdDateTime > b.createdDateTime ? a : b);
                    $('.cal-inspection-fee').show();
                    if(!mostRecentFee || mostRecentFee !=null){
                        //$('.cal-inspection-fee span').text('$'+Math.round(mostRecentFee.defaultFee));
                        $('.cal-inspection-fee').text(`An inspection fee of $${Math.round(mostRecentFee.fee)} will apply to this appointment.`);
                    }
                 }else{
                    $('.cal-inspection-fee').hide();
                 }
                 
                 
            }
        },
        error: function(data){
            $('.cal-inspection-fee').hide();
        }
    });
}